<mat-form-field appearance="fill">
  <mat-label>Kategória elnevezése</mat-label>
  <input matInput value="" [(ngModel)]="instance.name">
</mat-form-field>
<div class="save-button">
  <app-button
    (click)="save()"
    [title]="'Mentés'"
    [customColor]="'green'"
  ></app-button>
</div>
